<template>
  <div class="container">
    <memlist-modal
      size="lg"
      :title="creating ? $t('MEMBER_RELATION.CREATING') : $t('MEMBER_RELATION.EDITING')"
      ref="edit-form"
      >

      <!-- Edit form -->
      <MemberFamilyEditor
        v-if="selected_member_relation"
        :member="member"
        :item="selected_member_relation"
        :creating="creating"
        @cancel="() => { this.$refs['edit-form'].hide(); }"
        @created="family_member_created"
        @updated="family_member_updated"
      />


    </memlist-modal>

    <CollapsibleListItem icon="mdi-home-heart" :title="$t('MEMBER.FAMILY')" :expanded="false">
      <memlist-static-table
        id="member-table"
        style="width: 100%; table-layout: fixed;"
        class="table-striped"
        :fields="fields"
        :items="items"
        head-variant="light"
        ref="memberTable"
      >
        <template #cell(actions)="row">
          <div class='d-flex justify-content-end'>
            <memlist-table-button v-if="!row.item.main" class="mr-2" @click="edit_family_member(row.item)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
            <memlist-table-button v-if="!row.item.main" @click="delete_family_member(row.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />

          </div>

        </template>

      </memlist-static-table>
    </CollapsibleListItem>

  </div>

</template>


<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { is_mobile } from '@/core/services/utils';
import MemberFamilyEditor from './MemberFamilyEditor.vue';
import CollapsibleListItem from './CollapsibleListItem.vue';

export default {

  name: 'MemberTableFamily',

  props: ['member','items','company','expanded'],
  emits: ['save_data', 'created', 'updated'],
  mixins: [ toasts ],

  components: {
    MemberFamilyEditor,
    CollapsibleListItem
  },

  watch: {

  },

  computed: {
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {

    async edit_family_member(member_relation_record) {
      try {
        this.selected_member_relation = member_relation_record;
        this.creating = false;

        this.$nextTick(()=>{
          this.$refs['edit-form'].show();
        });

      }
      catch (err) {
        console.error('edit_family_member error', err);
      }
    },

    family_member_created(family_member) {
      this.$emit('created', family_member);

      this.$refs['edit-form'].hide();
    },

    family_member_updated(family_member) {
      this.$emit('updated', family_member);

      this.$refs['edit-form'].hide();
    },

    async delete_family_member(member_id) {
      try {

      }
      catch (err) {
        console.error('delete_family_member error', err);
      }
    },


    async save_data() {

      this.$emit('save_data', this.member);

    }

  },

  mounted() {
    this.show_form = this.expanded;

    if (this.is_mobile) {
      this.fields = this.fields.filter((field) => {
        return field.mobile;
      });
    }
  },

  data() {
    return {

      creating: false,

      selected_member_relation: null,

      fields: [
        {
          key: 'member_id',
          label: this.$t('MEMBER.HD'),
          mobile: true,
          sortable: false,
          tdClass: 'td-short2',
          thClass: 'td-short2',
          formatter: (_, __, item) => {
            return item.main ? this.$t('COMMON.YES') : this.$t('COMMON.NO');
          }
        },
        {
          key: 'rel_member.firstname',
          label: this.$t('MEMBER.FIRSTNAME'),
          mobile: true,
          sortable: false,
          tdClass: 'td-short2',
          thClass: 'td-short2',
          formatter: (_, __, item) => {
            return item.main ? item.member.firstname : item.rel_member.firstname;
          }
        },

        {
          key: 'rel_member.lastname',
          label: this.$t('MEMBER.LASTNAME'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short2',
          thClass: 'td-short2',
          formatter: (_, __, item) => {
            return item.main ? item.member.lastname : item.rel_member.lastname;
          }
        },

        {
          key: 'rel_member.email',
          label: this.$t('MEMBER.EMAIL'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short2',
          thClass: 'td-short2',
          formatter: (_, __, item) => {
            return item.main ? item.member.email : item.rel_member.email;
          }
        },

        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          mobile: false,
          sortable: false,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },

      ],

      show_form: true,

    };
  }
};

</script>

<style lang="scss" scoped>
  
  
</style>
